import React from "react";
import theme from "../theme/theme";

const ErrorPage = ({ message = "حدث خطأ ما!", onRetry }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        height: "100vh",
        background:theme.colors.primary,  
        color: theme.colors.secondary,  
      }}
    >
      <h1 style={{ fontSize: "3.5rem", fontWeight: "bold" }}>خطأ!</h1>
      <p style={{ fontSize: "1.5rem", marginBottom: "20px" }}>{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: "10px 20px",
            background: theme.colors.secondary,  
            color: theme.colors.primary,  
            border: "none",
            borderRadius: "5px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          حاول مرة أخرى
        </button>
      )}
    </div>
  );
};

export default ErrorPage;
